import { render, staticRenderFns } from "./SeriesDetails.vue?vue&type=template&id=4dfbfef3"
import script from "./SeriesDetails.vue?vue&type=script&lang=js"
export * from "./SeriesDetails.vue?vue&type=script&lang=js"
import style0 from "./SeriesDetails.vue?vue&type=style&index=0&id=4dfbfef3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports